'use es6';

import { combineReducers } from 'redux';
import files from './Files';
import { folders } from './Folders';
import options from './Options';
import selections from './Selections';
import assets from './Assets';
import actionModal from './ActionModal';
import themes from './Themes';
import functions from './Functions';
import projects from './Projects';
export default combineReducers({
  files,
  folders,
  options,
  selections,
  assets,
  actionModal,
  themes,
  functions,
  projects
});